import { Component } from '@angular/core';

@Component({
  selector: 'app-lender-form',
  templateUrl: './lender-form.component.html',
  styleUrls: ['./lender-form.component.scss'],
  standalone: false,
})
export class LenderFormComponent {}
